import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const { top, bottom } = this.element.getBoundingClientRect()
    if (top >= 0 && bottom <= window.innerHeight) return

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    this.element.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' })
  }
}
